import { types } from "../actions";

const initialState = {
  Events: [],
  Location: { siteid: "", floorid: "", areaid: "" },
  Companion: [],
  Severity: [],
  Status: [],
  startTime: "",
  endTime: "",
};

const eventSettingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.EVENT_SETTINGS:
      return {
        ...action.payload,
      };
    default:
      return state;
  }
};

export default eventSettingsReducer;
